// src/main.js
import { createApp, h } from 'vue'
import App           from './App.vue'
import SvgIcon       from "@/components/SvgIcon.vue"
import { useProvideTiptapStore } from '@/tiptap/hooks/use-store'
import { createContext } from '@/tiptap/hooks/use-context'
import allExtensions from '@/tiptap/extensions/all'
import './styles/fonts.css'

// Plugins
import { createPinia } from 'pinia'
import router          from './router'
import vuetify         from './plugins/vuetify'

import axios from 'axios'
import { useUserStore } from '@/stores/user';

// Axios CSRF defaults
axios.defaults.xsrfCookieName  = 'csrftoken'
axios.defaults.xsrfHeaderName  = 'X-CSRFToken'
axios.defaults.withCredentials = true

// Initialize app only after fetching CSRF cookie
async function initApp() {
  try {
    await axios.get('/api/get-csrf/')
    console.log('✅ CSRF cookie fetched')
  } catch (err) {
    console.warn('⚠️ Could not fetch CSRF cookie, proceeding anyway', err)
  }

  // Initialize TipTap global context with all extensions
  createContext({ extensions: allExtensions })

  const pinia = createPinia();

  const RootApp = {
    setup() {
      // Provide the global TipTap store once at the root
      useProvideTiptapStore()
      return () => h(App)
    }
  }

  const app = createApp(RootApp);
  app.use(pinia)
     .use(vuetify)
     .component('SvgIcon', SvgIcon);

  // Bootstrap auth before mounting
  const userStore = useUserStore(pinia);
  await userStore.fetchUser();

  // 3b) Install router after auth
  app.use(router);

  // Wait for initial route resolution after auth
  await router.isReady();

  // Allow unauthenticated access to public auth endpoints
  const publicEndpoints = [
    '/api/get-csrf/',
    '/api/auth/get-csrf/',
    '/api/auth/password/reset/',
    '/api/auth/password/reset/confirm/'
  ];

  axios.interceptors.request.use(config => {
    // Allow public endpoints without authentication
    if (publicEndpoints.some(url => config.url.startsWith(url))) {
      return config;
    }
    const userStore = useUserStore(pinia);
    if (!userStore.user) {
      return Promise.reject(new axios.Cancel('Not authenticated – request canceled.'));
    }
    return config;
  }, err => Promise.reject(err));

  app.mount('#app')
}

initApp()
